<script setup>
  import Login from '@/components/Auth/Login.vue'
</script>
<template>
    <div class="wrapper">
        <div class="container d-flex centered">
          <router-view/>
        </div>
    </div>

</template>

<style scoped>
.wrapper {
    background-image: url('~@/assets/split-map.svg');
    background-repeat: no-repeat;
    background-position: 0;
    background-position-x: 100%;
    background-size: 55%;
}

.wrapper {
  padding-top: 8rem;
}
</style>
